import React,{useState,useEffect} from "react"
import { useLocation as location2 } from "wouter";
import Loading from "../components/Loading";
import post from '../post';
import Alert from "../components/Alert";
import nl2br from "react-nl2br";
const TipoSelect = () => {
    const user_id = localStorage.getItem('token');
    const [opened,setOpened]=useState(false);
    const [location, navigate] = location2();
    const [loading,setLoading]=useState(true);
    const [userData,setUserData]=useState({});
    const [alert, setAlert] = useState({ isOpen: false, title: '', message: '' });
    const [restaurants,setRestaurants]=useState([]);
    if (!user_id) {
        navigate('/login');
    }

    const [currentOrder, setCurrentOrder] = useState({});

    const handleAddressSelect = async (addressId) => {
        setLoading(true);
        const l=await post('selectAddress',{cliente_id:addressId});
        setLoading(false);
        if(!l.result){
            setAlert({ isOpen: true, title: 'Error', message: l.motive || 'Error al seleccionar la dirección. Por favor, intenta de nuevo.' });
            return;
        }
        if(!l.data.status){
            setAlert({ isOpen: true, title: 'Error', message: l.data.error || 'Error al seleccionar la dirección. Por favor, intenta de nuevo.' });
            return;
        }
        const newOrder={tipo:'delivery',cliente_id:addressId,sucursal_id:l.data.sucursal.id,xtra_data:
            userData.direcciones.find(d=>d.id==addressId) || {}
        };
        setCurrentOrder(newOrder);
        localStorage.setItem('currentOrder', JSON.stringify(newOrder));
    }
    const handleRestaurantSelect = async (restaurantId) => {
        console.log('restaurantId:',restaurantId);
        localStorage.setItem('currentOrder', JSON.stringify({tipo:'out',sucursal_id:restaurantId,xtra_data:
            restaurants.find(r=>r.id==restaurantId) || {}
        }));
        setCurrentOrder({tipo:'out',sucursal_id:restaurantId,xtra_data:
            restaurants.find(r=>r.id==restaurantId) || {}
        });
    }
    useEffect(() => {
        const currentOrder = localStorage.getItem('currentOrder');
        if (currentOrder) {
            setCurrentOrder(JSON.parse(currentOrder || {}));
        }
        const fetchData = async () => {
            setLoading(true);
            const response = await post('getUserData',{});
            const rr=await post('getRestaurants',{});
            if(rr.result && rr.data && rr.data.length>0){
                setRestaurants(rr.data);
            }
            setLoading(false);
            if(!response.result){
                navigate('/login');
                return;
            }
            setUserData(response.data);
        };
        fetchData();
    }, []);

    return (
        <div id="webcrumbs">
            <Loading isOpen={loading} />
            <Alert isOpen={alert.isOpen} title={alert.title} message={alert.message} onClose={() => setAlert({ isOpen: false, title: '', message: '' })} />
            <div className="text-neutral-700 min-h-screen bg-gradient-to-b from-primary-50 to-white relative pb-16 flex flex-col items-center justify-center">
                <div className="w-full max-w-3xl px-6 py-10">
                    <div className="flex flex-col items-center mb-8">
                        <div className="w-16 h-16 bg-primary-600 rounded-full flex items-center justify-center mb-4 shadow-lg transform hover:rotate-12 transition-all">
                            <span className="material-symbols-outlined text-white text-3xl">local_shipping</span>
                        </div>
                        <h1 className="text-3xl font-bold text-neutral-900 mb-1">Opciones de Entrega</h1>
                        <p className="text-neutral-600 text-center">
                            Seleccione su método preferido para recibir su pedido
                        </p>
                    </div>

                    <div className="bg-white rounded-2xl shadow-sm border border-neutral-100 p-6 mb-6 backdrop-blur-sm">
                        <div className="space-y-4">
                            <details open={!currentOrder || !currentOrder?.tipo || currentOrder?.tipo=='delivery'} className="group rounded-xl border border-neutral-200 [&_summary::-webkit-details-marker]:hidden">
                                <summary className="flex cursor-pointer items-center justify-between gap-1.5 rounded-xl bg-white p-5 text-neutral-900 hover:bg-neutral-50 transition-all">
                                    <div className="flex items-center gap-4">
                                        <span className="material-symbols-outlined text-primary-600">home</span>
                                        <h3 className="font-medium">Envío a domicilio</h3>
                                    </div>
                                    <span className="material-symbols-outlined text-neutral-500 transition duration-300 group-open:rotate-180">
                                        expand_more
                                    </span>
                                </summary>

                                <div className="border-t border-neutral-100 p-5">
                                    <div className="space-y-3">
                                        <div className="text-sm text-neutral-600 mb-4">
                                            Seleccione la dirección de entrega:
                                        </div>

                                        <div className="space-y-3">
                                            {userData.direcciones && userData.direcciones.length > 0 ? (
                                                userData.direcciones.map((address, index) => (
                                                    <div
                                                        key={`addressContainer${index}_${address.id}`}
                                                        className="flex items-center p-3 border border-neutral-200 rounded-lg hover:border-primary-300 hover:bg-primary-50 transition-all cursor-pointer"
                                                         onClick={()=>{handleAddressSelect(address.id)}}    
                                                    >
                                                    <input
                                                        type="radio"
                                                        name="address"
                                                        key={`address${index}`}
                                                        className="h-4 w-4 text-primary-600 mr-3"
                                                        checked={currentOrder?.tipo=='delivery' && currentOrder?.cliente_id==address.id}
                                                       
                                                    />
                                                    <label htmlFor="address1" className="flex-1">
                                                        <div className="font-medium">{address.nombre} {address.paterno} {address.materno}</div>
                                                        <div className="text-sm text-neutral-600">
                                                            {address.calle} {address.ext} {address.int?'Int. '+address.int:''}. {address.colonia}, {address.delegacion}, {address.estado} {address.cp}
                                                        </div>
                                                    </label>
                                                </div>
                                                ))) : (
                                                <div className="text-sm text-neutral-600">
                                                    No hay direcciones guardadas. Por favor, añada una nueva dirección.
                                                </div>
                                                )}
                                            

                                           

                                            
                                        </div>

                                        <button className="mt-4 flex items-center text-primary-600 hover:text-primary-700 transition-all">
                                            <span className="material-symbols-outlined text-sm mr-1">add_circle</span>
                                            <span className="text-sm">Añadir nueva dirección</span>
                                        </button>
                                    </div>
                                </div>
                            </details>

                            <details open={currentOrder?.tipo=='out'} className="group rounded-xl border border-neutral-200 [&_summary::-webkit-details-marker]:hidden">
                                <summary className="flex cursor-pointer items-center justify-between gap-1.5 rounded-xl bg-white p-5 text-neutral-900 hover:bg-neutral-50 transition-all">
                                    <div className="flex items-center gap-4">
                                        <span className="material-symbols-outlined text-primary-600">restaurant</span>
                                        <h3 className="font-medium">Recoger en el restaurante</h3>
                                    </div>
                                    <span className="material-symbols-outlined text-neutral-500 transition duration-300 group-open:rotate-180">
                                        expand_more
                                    </span>
                                </summary>

                                <div className="border-t border-neutral-100 p-5">
                                    <div className="space-y-3">
                                        <div className="text-sm text-neutral-600 mb-4">
                                            Seleccione el restaurante para recoger su pedido:
                                        </div>
                                        {restaurants && restaurants.length > 0 ? (
                                            restaurants.map((r, index) =>
                                            (<div 
                                                key={`restaurantContainer${index}`}
                                                className="flex items-center p-3 border border-neutral-200 rounded-lg hover:border-primary-300 hover:bg-primary-50 transition-all cursor-pointer"
                                               onClick={()=>{handleRestaurantSelect(r.id)}}
                                            >
                                                <input
                                                    type="radio"
                                                    name="restaurant"
                                                    className="h-4 w-4 text-primary-600 mr-3"
                                                    checked={currentOrder?.tipo=='out' && currentOrder?.sucursal_id==r.id}
                                                />
                                                <label htmlFor="restaurant1" className="flex-1">
                                                    <div className="font-medium">{r.nombre} </div>
                                                    <div className="text-sm text-neutral-600">
                                                        {nl2br(r.direccion)}
                                                    </div>
                                                    <div className="text-xs text-neutral-500 mt-1">
                                                        Abierto: {r.delivery_hours[(new Date()).getDay()].join(' - ')}
                                                    </div>
                                                </label>
                                            </div>)
                                            )
                                        ) : (
                                            <div className="text-sm text-neutral-600">
                                                No hay restaurantes disponibles para recogida en este momento.
                                            </div>
                                        )}
                                        <div className="space-y-3">
                                            

                                            

                                           
                                        </div>

                                        <div className="mt-4 flex items-center text-neutral-600 text-sm">
                                            <span className="material-symbols-outlined text-sm mr-1">info</span>
                                            <span>El tiempo estimado de preparación es de 15-20 minutos</span>
                                        </div>
                                    </div>
                                </div>
                            </details>

                            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-6">
                                <button
                                    type="button"
                                    className="w-full flex items-center justify-center space-x-2 bg-neutral-200 text-neutral-800 py-3.5 rounded-xl font-medium shadow-sm hover:bg-neutral-300 transition-all transform hover:scale-[1.01] active:scale-[0.99]"
                                    onClick={() => navigate('/')}
                                >
                                    <span className="material-symbols-outlined">arrow_back</span>
                                    <span>Regresar</span>
                                </button>
                                <button
                                    type="button"
                                    disabled={!currentOrder || !currentOrder?.tipo}
                                    onClick={() => navigate('/order')}
                                    className="w-full flex items-center justify-center space-x-2 bg-primary-600 text-white py-3.5 rounded-xl font-medium shadow-sm hover:bg-primary-700 transition-all transform hover:scale-[1.01] active:scale-[0.99] disabled:opacity-50"
                                >
                                    
                                    <span>Continuar</span>
                                    <span className="material-symbols-outlined">arrow_forward</span>
                                </button>
                            </div>

                            
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default TipoSelect;